// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H9xA","controls":"styles_controls__KWjv8","charLimit":"styles_charLimit__dRmHI","input":"styles_input__3ClhA","send":"styles_send__1TRof"};